<template>
	<div>
		<div style="background:#00A6E5;display: flex;justify-content: center;">
			<div style="height: 80px;width: 60%;display: flex;align-items: center;justify-content: space-between;">
				<div style="display: flex;align-items: center;">
					<img src="../static/images/morning.png" style="width: 205px;height:39px;" alt="">
				</div>
			</div>
		</div>
		<div style="display: flex;align-items: center;flex-direction: column;">
			<img src="../static/images/welcome_bg.png" style="width: 350px;height: 247px;margin-top: 144px;" alt="">
			<button style="margin-top:92px;border:none;width: 320px;height: 56px;background: #00A6E5;border-radius: 4px;font-size: 20px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 28px;cursor: pointer;" @click="goHome">立即体验</button>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Welcome',
		props: {
			msg: String
		},
		data() {
			return {
				
			}
		},
		mounted() {
			this.loadData();
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			loadData() {

			},
			goHome(){
				this.$router.push('/Home');
			}
		}
	}
</script>

<style scoped>
	.top_block {
		height: 200px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
		border-radius: 4px;
		margin-top: 30px;
	}

	.img_left_block {
		display: flex;
		align-items: center;
	}

	.top_top {
		display: flex;
		justify-content: space-between;
		padding: 20px 30px 40px 30px;
	}

	.tips_item {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tips_str {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 18px;
	}

	.tips_val {
		font-size: 16px;
		font-family: Helvetica;
		color: #333333;
		line-height: 19px;
		margin-top: 6px;
	}

	.title_bar {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 25px;
	}
	.table_all{
		width: 100%;
		border: 1px solid #EDEFF1;
		border-collapse:collapse;  
		border-spacing:0px;
		margin-top: 20px;
	}
	.table_all th{
		background: #F1F5F7;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 48px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;

	}
	.table_all td{
		background: #FFFFFF;
		border: 1px solid #EDEFF1;
		text-align: center;
		height: 54px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
	}
	.item_row{
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 60%;
		margin-top: 20px;
	}
	.item_name{
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #6C757D;
		line-height: 20px;
		flex:2;
	}
	.input_val{
		background: #FFFFFF;
		border-radius: 3px;
		border: 1px solid #CED4DA;
		flex: 8;
		padding: 9px 16px 9px 16px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		line-height: 20px;
	}
</style>
